"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = exports.SubscriptionPlanType = exports.SnapshotType = exports.GlobalSettingType = exports.DataSourceType = exports.DataImportWarningType = exports.DataImportStatusLevel = exports.DataImportRunTaskStage = exports.DataImportErrorType = exports.ButtonClickActionType = exports.AlertType = exports.AddonPlatform = void 0;
var axios_1 = __importDefault(require("axios"));
var common_1 = require("./common");
var base_1 = require("./base");
exports.AddonPlatform = {
    Excel: 'excel',
    GoogleSheets: 'google_sheets'
};
exports.AlertType = {
    MonitorChange: 'monitor_change',
    MonitorCondition: 'monitor_condition',
    NewRowsAppended: 'new_rows_appended',
    NewRowsWithId: 'new_rows_with_id',
    Snapshot: 'snapshot'
};
exports.ButtonClickActionType = {
    OpenBillingOptions: 'open_billing_options',
    AuthRequired: 'auth_required',
    ChangeSource: 'change_source'
};
exports.DataImportErrorType = {
    ImportPreempted: 'import_preempted',
    ImportKilledUnexpectedly: 'import_killed_unexpectedly',
    ImportRefreshLimitReached: 'import_refresh_limit_reached',
    ExcelSheetStateNotAvailable: 'excel_sheet_state_not_available',
    ExcelFileSizeLimitReached: 'excel_file_size_limit_reached',
    ExcelFileSizeLimitWillBeReached: 'excel_file_size_limit_will_be_reached',
    CellRefRangeNotFound: 'cell_ref_range_not_found',
    CouldNotFetchCsvUrl: 'could_not_fetch_csv_url',
    CollectionNotFound: 'collection_not_found',
    CsvUrlAuthError: 'csv_url_auth_error',
    CsvUrlNotFound: 'csv_url_not_found',
    CsvUrlTimeout: 'csv_url_timeout',
    CsvFieldLimitExceeded: 'csv_field_limit_exceeded',
    DataSourceNeedsReauth: 'data_source_needs_reauth',
    GoogleDriveFileNotFound: 'google_drive_file_not_found',
    GoogleSheetsCellLimitExceeded: 'google_sheets_cell_limit_exceeded',
    GoogleSheetsCellContentExceeded: 'google_sheets_cell_content_exceeded',
    TargetGoogleSheetsFileNotFound: 'target_google_sheets_file_not_found',
    GoogleSheetsReadTimedOut: 'google_sheets_read_timed_out',
    GoogleSheetsNotResponding: 'google_sheets_not_responding',
    GoogleSheetsServiceUnavailable: 'google_sheets_service_unavailable',
    GoogleSheetsWriteBatchFail: 'google_sheets_write_batch_fail',
    GoogleSheetsInternalServerError: 'google_sheets_internal_server_error',
    GoogleSheetsQuotaExceeded: 'google_sheets_quota_exceeded',
    TargetSheetProtected: 'target_sheet_protected',
    TargetGoogleSheetsTabDeleted: 'target_google_sheets_tab_deleted',
    SourceGoogleSheetsTabDeleted: 'source_google_sheets_tab_deleted',
    TargetExcelWorkbookNotFound: 'target_excel_workbook_not_found',
    ExcelCantCreateWorkbookSession: 'excel_cant_create_workbook_session',
    ExcelWorkbookNotSupported: 'excel_workbook_not_supported',
    TargetExcelWorksheetNotFound: 'target_excel_worksheet_not_found',
    TargetSheetInsufficientPermission: 'target_sheet_insufficient_permission',
    ArrayFormulaInDataTable: 'array_formula_in_data_table',
    InvalidCsvContentType: 'invalid_csv_content_type',
    InvalidCsvUrl: 'invalid_csv_url',
    NamedRangeParameterNotFound: 'named_range_parameter_not_found',
    NamedRangeParameterCellEmpty: 'named_range_parameter_cell_empty',
    NamedRangeParameterCellInvalid: 'named_range_parameter_cell_invalid',
    ParametrizedFilterCellEmpty: 'parametrized_filter_cell_empty',
    ExcelParameterReadError: 'excel_parameter_read_error',
    PivotTooManyColumns: 'pivot_too_many_columns',
    PivotDatasetTooLarge: 'pivot_dataset_too_large',
    PivotUnsupportedOptions: 'pivot_unsupported_options',
    SkipRowsOutOfRange: 'skip_rows_out_of_range',
    GoogleSheetsSourceTabNotFound: 'google_sheets_source_tab_not_found',
    GoogleSheetsInsufficientPermission: 'google_sheets_insufficient_permission',
    SourceDataIsEmpty: 'source_data_is_empty',
    SqlExecutionError: 'sql_execution_error',
    SqlSyntaxError: 'sql_syntax_error',
    SqlFixableError: 'sql_fixable_error',
    SqlTableNotFound: 'sql_table_not_found',
    SqlColumnNotFound: 'sql_column_not_found',
    SqlInsufficientPrivilege: 'sql_insufficient_privilege',
    SqlInvalidCredentials: 'sql_invalid_credentials',
    SqlSshInvalidCredentials: 'sql_ssh_invalid_credentials',
    SqlConnectionTimeout: 'sql_connection_timeout',
    SqlOperationalError: 'sql_operational_error',
    MssqlCheckHostPort: 'mssql_check_host_port',
    MssqlSslError: 'mssql_ssl_error',
    MysqlHostNotWhitelisted: 'mysql_host_not_whitelisted',
    SnowflakeIpNotAllowed: 'snowflake_ip_not_allowed',
    SnowflakeNoDefaultWarehouse: 'snowflake_no_default_warehouse',
    SnowflakeIncorrectWarehouse: 'snowflake_incorrect_warehouse',
    SnowflakeNoWarehousesFound: 'snowflake_no_warehouses_found',
    SnowflakeFreeTrialExpired: 'snowflake_free_trial_expired',
    SnowflakeInvalidAccountName: 'snowflake_invalid_account_name',
    SnowflakeUserDisabled: 'snowflake_user_disabled',
    SnowflakeUserTemporarilyLocked: 'snowflake_user_temporarily_locked',
    SnowflakeInvalidObject: 'snowflake_invalid_object',
    SnowflakeConnectionError: 'snowflake_connection_error',
    SnowflakeUnknownError: 'snowflake_unknown_error',
    LookerUnknownUrlType: 'looker_unknown_url_type',
    LookerCannotRunQuery: 'looker_cannot_run_query',
    LookerNotFound: 'looker_not_found',
    LookerModelOrExploreNotFound: 'looker_model_or_explore_not_found',
    LookerQueryTimeout: 'looker_query_timeout',
    LookerInsufficientPermissions: 'looker_insufficient_permissions',
    LookerInvalidCredentials: 'looker_invalid_credentials',
    LookerUserAccountTemporarilyLocked: 'looker_user_account_temporarily_locked',
    LookerMissingValuesNotFilled: 'looker_missing_values_not_filled',
    LookerUnableCreateClientApp: 'looker_unable_create_client_app',
    LookerAuthExpired: 'looker_auth_expired',
    NetflixQuiverViewNotFound: 'netflix_quiver_view_not_found',
    NetflixQuiverCannotRunQuery: 'netflix_quiver_cannot_run_query',
    NetflixQuiverInvalidCredentials: 'netflix_quiver_invalid_credentials',
    NetflixQuiverNestedFiltersNotSupported: 'netflix_quiver_nested_filters_not_supported',
    NetflixQuiverUnknownError: 'netflix_quiver_unknown_error',
    NetflixQuiverOauthConfigurationRemoved: 'netflix_quiver_oauth_configuration_removed',
    NetflixQuiverMissingPivotFields: 'netflix_quiver_missing_pivot_fields',
    NetflixQuiverInvalidValuesFields: 'netflix_quiver_invalid_values_fields',
    NetflixQuiverAuthServerError: 'netflix_quiver_auth_server_error',
    SalesforceInvalidTypeForOperation: 'salesforce_invalid_type_for_operation',
    SalesforceRequestLimitExceeded: 'salesforce_request_limit_exceeded',
    SalesforceRunReportRateLimit: 'salesforce_run_report_rate_limit',
    SalesforceMalformedQuery: 'salesforce_malformed_query',
    SalesforceInvalidField: 'salesforce_invalid_field',
    SalesforceMissingReportOrObject: 'salesforce_missing_report_or_object',
    SalesforceInvalidReport: 'salesforce_invalid_report',
    SalesforceUnknownError: 'salesforce_unknown_error',
    SalesforceQueryFailed: 'salesforce_query_failed',
    SalesforceServerError: 'salesforce_server_error',
    SalesforceMissingExportReportsPermission: 'salesforce_missing_export_reports_permission',
    SalesforceMissingRunReportsPermission: 'salesforce_missing_run_reports_permission',
    SalesforceApiDisabled: 'salesforce_api_disabled',
    SalesforceReportNotCsv: 'salesforce_report_not_csv',
    SalesforceQueryTimeout: 'salesforce_query_timeout',
    SalesforceServiceUnavailable: 'salesforce_service_unavailable',
    SalesforceBadRequest: 'salesforce_bad_request',
    SalesforceTooManyRequests: 'salesforce_too_many_requests',
    SalesforceUnauthorizedError: 'salesforce_unauthorized_error',
    SalesforceUriLengthExceeded: 'salesforce_uri_length_exceeded',
    SalesforceRequestSizeExceeded: 'salesforce_request_size_exceeded',
    SalesforceExportReportError: 'salesforce_export_report_error',
    SalesforceReportTypeNotSupported: 'salesforce_report_type_not_supported',
    SalesforceHighAssuranceSessionRequired: 'salesforce_high_assurance_session_required',
    SalesforceAsyncFetchDataError: 'salesforce_async_fetch_data_error',
    SalesforceAsyncReportTimeoutError: 'salesforce_async_report_timeout_error',
    GanalyticsDimsMetricsCannotGoTogether: 'ganalytics_dims_metrics_cannot_go_together',
    GanalyticsServiceUnavailable: 'ganalytics_service_unavailable',
    GanalyticsBadRequest: 'ganalytics_bad_request',
    GanalyticsInsufficientPermissions: 'ganalytics_insufficient_permissions',
    Ga4UnknownError: 'ga4_unknown_error',
    Ga4PermissionError: 'ga4_permission_error',
    Ga4ServiceUnavailable: 'ga4_service_unavailable',
    FbAdsUnknownError: 'fb_ads_unknown_error',
    FbAdsAsyncJobSkipped: 'fb_ads_async_job_skipped',
    FbAdsApiRateLimitExceeded: 'fb_ads_api_rate_limit_exceeded',
    FbAdsApiBadRequest: 'fb_ads_api_bad_request',
    FbAdsInsufficientPermissionsGrantedByUser: 'fb_ads_insufficient_permissions_granted_by_user',
    FbAdsAccountMissingAccessForAdsAccount: 'fb_ads_account_missing_access_for_ads_account',
    FbAdsCustomMetricEvaluationError: 'fb_ads_custom_metric_evaluation_error',
    FbInsightsUnknownError: 'fb_insights_unknown_error',
    FbInsightsApiRateLimitExceeded: 'fb_insights_api_rate_limit_exceeded',
    FbInsightsApiBadRequest: 'fb_insights_api_bad_request',
    FbInsightsNoMetricsSelected: 'fb_insights_no_metrics_selected',
    FbInsightsInsufficientPermissionsGrantedByUser: 'fb_insights_insufficient_permissions_granted_by_user',
    FbInsightsUnsupportedQueryError: 'fb_insights_unsupported_query_error',
    CalendlyApiRateLimitExceeded: 'calendly_api_rate_limit_exceeded',
    Ga4DimensionsLimitExceededError: 'ga4_dimensions_limit_exceeded_error',
    Ga4MetricsLimitExceededError: 'ga4_metrics_limit_exceeded_error',
    Ga4DimensionsAndMetricsIncompatibleError: 'ga4_dimensions_and_metrics_incompatible_error',
    Ga4BadRequestError: 'ga4_bad_request_error',
    Ga4ApiRateLimitExceeded: 'ga4_api_rate_limit_exceeded',
    GdriveServiceUnavailable: 'gdrive_service_unavailable',
    GdriveBadRequest: 'gdrive_bad_request',
    HubspotUnknownError: 'hubspot_unknown_error',
    HubspotServiceUnavailable: 'hubspot_service_unavailable',
    HubspotInternalError: 'hubspot_internal_error',
    HubspotApiRateLimitExceeded: 'hubspot_api_rate_limit_exceeded',
    HubspotTooManyFilters: 'hubspot_too_many_filters',
    HubspotTooManyFilterGroups: 'hubspot_too_many_filter_groups',
    HubspotFiltersMaxNestingLevelsExceeded: 'hubspot_filters_max_nesting_levels_exceeded',
    SalesforceFiltersMaxNestingLevelsExceeded: 'salesforce_filters_max_nesting_levels_exceeded',
    HubspotTooManySorts: 'hubspot_too_many_sorts',
    HubspotInsufficientPermissions: 'hubspot_insufficient_permissions',
    HubspotInsufficientPermissionsV2: 'hubspot_insufficient_permissions_v2',
    HubspotFilterTooManyMatches: 'hubspot_filter_too_many_matches',
    HubspotInvalidFilters: 'hubspot_invalid_filters',
    HubspotTooManyDatePointsRequested: 'hubspot_too_many_date_points_requested',
    HubspotNotFound: 'hubspot_not_found',
    HubspotBadRequest: 'hubspot_bad_request',
    HubspotObjectNotActivated: 'hubspot_object_not_activated',
    TableauInvalidEndpoint: 'tableau_invalid_endpoint',
    TableauWorksheetNotFound: 'tableau_worksheet_not_found',
    TableauRepatedMeasureName: 'tableau_repated_measure_name',
    TableauRepatedMeasureValues: 'tableau_repated_measure_values',
    TableauUnknownError: 'tableau_unknown_error',
    TableauServiceUnavailable: 'tableau_service_unavailable',
    TableauInsufficientPermissions: 'tableau_insufficient_permissions',
    TableauAuthExpired: 'tableau_auth_expired',
    TableauCustomViewNotSupported: 'tableau_custom_view_not_supported',
    OperationTimeoutError: 'operation_timeout_error',
    CeleryTimeoutError: 'celery_timeout_error',
    CeleryQueueTimeoutError: 'celery_queue_timeout_error',
    FreeTrialExpired: 'free_trial_expired',
    ImportRunBlockedDueToPremiumConnector: 'import_run_blocked_due_to_premium_connector',
    ImportRunBlockedDueToDataSourceConnectionLimit: 'import_run_blocked_due_to_data_source_connection_limit',
    ImportBlockedUnlicensedUser: 'import_blocked_unlicensed_user',
    JiraUnavailableFilterError: 'jira_unavailable_filter_error',
    JiraServiceUnavailableError: 'jira_service_unavailable_error',
    JiraUnknownError: 'jira_unknown_error',
    JiraRateLimitExceeded: 'jira_rate_limit_exceeded',
    JiraForbiddenError: 'jira_forbidden_error',
    InstagramUnknownError: 'instagram_unknown_error',
    InstagramInsufficientPermission: 'instagram_insufficient_permission',
    ZendeskUnknownError: 'zendesk_unknown_error',
    ZendeskRateLimitExceeded: 'zendesk_rate_limit_exceeded',
    ZendeskServiceUnavailable: 'zendesk_service_unavailable',
    ZendeskInsufficientPermission: 'zendesk_insufficient_permission',
    ZendeskHelpdeskNoLongerAvailable: 'zendesk_helpdesk_no_longer_available',
    QuickbooksUnknownError: 'quickbooks_unknown_error',
    QuickbooksAuthenticationError: 'quickbooks_authentication_error',
    QuickbooksInvalidCustomRangeError: 'quickbooks_invalid_custom_range_error',
    QuickbooksRateLimitExceeded: 'quickbooks_rate_limit_exceeded',
    PaymoRateLimitExceeded: 'paymo_rate_limit_exceeded',
    QuickbooksValidationError: 'quickbooks_validation_error',
    QuickbooksProjectsNotAvailable: 'quickbooks_projects_not_available',
    ShopifyUnknownError: 'shopify_unknown_error',
    ShopifyAccessDenied: 'shopify_access_denied',
    ShopifyAnotherQueryInProgress: 'shopify_another_query_in_progress',
    ShopifyQueryTimeout: 'shopify_query_timeout',
    ShopifyRateLimitExceeded: 'shopify_rate_limit_exceeded',
    ShopifyMaybeStoreLocked: 'shopify_maybe_store_locked',
    ShopifyTemporaryError: 'shopify_temporary_error',
    ShopifyQueryNotSupported: 'shopify_query_not_supported',
    ShopifyResourceNotFound: 'shopify_resource_not_found',
    ShopifyObjectNotSupported: 'shopify_object_not_supported',
    BigqueryUnknownError: 'bigquery_unknown_error',
    BigqueryInvalidGrantError: 'bigquery_invalid_grant_error',
    BigqueryPermissionError: 'bigquery_permission_error',
    StripeUnknownError: 'stripe_unknown_error',
    ImportNotSharedError: 'import_not_shared_error',
    DataSourceNotSharedError: 'data_source_not_shared_error',
    UncaughtException: 'uncaught_exception',
    GoogleSheetsApiTemporaryError: 'google_sheets_api_temporary_error',
    AirtableUnknownError: 'airtable_unknown_error',
    AirtableInsufficientPermissions: 'airtable_insufficient_permissions',
    AirtableNotFound: 'airtable_not_found',
    AirtableServiceUnavailable: 'airtable_service_unavailable',
    AirtableRateLimitExceeded: 'airtable_rate_limit_exceeded',
    DataSourceTypeKillSwitchEnabled: 'data_source_type_kill_switch_enabled',
    InvalidExcelContentType: 'invalid_excel_content_type',
    InvalidExcelUrl: 'invalid_excel_url',
    ExcelUrlAuthError: 'excel_url_auth_error',
    ExcelUrlNotFound: 'excel_url_not_found',
    ExcelUrlTimeout: 'excel_url_timeout',
    ExcelExecutingInstructionsError: 'excel_executing_instructions_error',
    CouldNotFetchExcelUrl: 'could_not_fetch_excel_url',
    MailchimpUnknownError: 'mailchimp_unknown_error',
    MailchimpDataNotFound: 'mailchimp_data_not_found',
    MailchimpTooManyRequests: 'mailchimp_too_many_requests',
    MailchimpServiceUnavailable: 'mailchimp_service_unavailable',
    PipedriveUnknownError: 'pipedrive_unknown_error',
    PipedrivePaymentRequired: 'pipedrive_payment_required',
    PipedriveRateLimitExceeded: 'pipedrive_rate_limit_exceeded',
    PipedriveServiceUnavailable: 'pipedrive_service_unavailable',
    PipedriveInternalError: 'pipedrive_internal_error',
    PipedriveBadRequest: 'pipedrive_bad_request',
    PipedriveTemporaryError: 'pipedrive_temporary_error',
    OneDriveUnknownError: 'one_drive_unknown_error',
    OneDriveRateLimitExceeded: 'one_drive_rate_limit_exceeded',
    OneDriveServiceUnavailable: 'one_drive_service_unavailable',
    OneDriveForbiddenError: 'one_drive_forbidden_error',
    SharepointListsForbiddenError: 'sharepoint_lists_forbidden_error',
    SharepointListsRateLimitExceeded: 'sharepoint_lists_rate_limit_exceeded',
    SharepointListsServiceUnavailable: 'sharepoint_lists_service_unavailable',
    SharepointListsUnknownError: 'sharepoint_lists_unknown_error',
    SharepointListsSiteNotFound: 'sharepoint_lists_site_not_found',
    SharepointListsListNotFound: 'sharepoint_lists_list_not_found',
    EgnyteUnknownError: 'egnyte_unknown_error',
    EgnyteRateLimitExceeded: 'egnyte_rate_limit_exceeded',
    EgnyteServiceUnavailable: 'egnyte_service_unavailable',
    EgnyteForbiddenError: 'egnyte_forbidden_error',
    EgnyteFileNotFound: 'egnyte_file_not_found',
    BoxUnknownError: 'box_unknown_error',
    BoxRateLimitExceeded: 'box_rate_limit_exceeded',
    BoxServiceUnavailable: 'box_service_unavailable',
    BoxForbiddenError: 'box_forbidden_error',
    ExcelFormatIncorrect: 'excel_format_incorrect',
    ExcelFilesizeExceeds: 'excel_filesize_exceeds',
    OutreachUnknownError: 'outreach_unknown_error',
    OutreachUnauthorizedRequest: 'outreach_unauthorized_request',
    OutreachRateLimitExceeded: 'outreach_rate_limit_exceeded',
    OutreachGatewayError: 'outreach_gateway_error',
    OutreachTooManySorts: 'outreach_too_many_sorts',
    OutreachDeprecatedFiltersSorts: 'outreach_deprecated_filters_sorts',
    ResourceExhausted: 'resource_exhausted',
    RateLimitExceeded: 'rate_limit_exceeded',
    RangeParsingFailure: 'range_parsing_failure',
    OutOfRangeValuesJsonNonComplaint: 'out_of_range_values_json_non_complaint',
    InvalidCredentialsRefreshAccessToken: 'invalid_credentials_refresh_access_token',
    GsheetsBadRequest: 'gsheets_bad_request',
    GscUnknownError: 'gsc_unknown_error',
    GscRateLimitExceeded: 'gsc_rate_limit_exceeded',
    GscServiceUnavailable: 'gsc_service_unavailable',
    GscNotFound: 'gsc_not_found',
    GscBadRequest: 'gsc_bad_request',
    GscServerError: 'gsc_server_error',
    GmailUnknownError: 'gmail_unknown_error',
    GmailRateLimitExceeded: 'gmail_rate_limit_exceeded',
    GmailServiceUnavailable: 'gmail_service_unavailable',
    GmailNotFound: 'gmail_not_found',
    GmailBadRequest: 'gmail_bad_request',
    GmailServerError: 'gmail_server_error',
    GoogleAdsUnknownError: 'google_ads_unknown_error',
    GoogleAdsBadRequest: 'google_ads_bad_request',
    GoogleAdsDataNotFound: 'google_ads_data_not_found',
    GoogleAdsMetricsAccessDenied: 'google_ads_metrics_access_denied',
    GoogleAdsTooManyRequests: 'google_ads_too_many_requests',
    GoogleAdsServiceUnavailable: 'google_ads_service_unavailable',
    GoogleAdsNotAdsUser: 'google_ads_not_ads_user',
    GoogleAdsPermissionDenied: 'google_ads_permission_denied',
    GoogleAdsCustomerAccountDeactivatedOrDisabled: 'google_ads_customer_account_deactivated_or_disabled',
    FeatureDisabled: 'feature_disabled',
    CloudTableDuplicateColumnNames: 'cloud_table_duplicate_column_names',
    CloudTableEmptyColumnNames: 'cloud_table_empty_column_names',
    CloudTableDataNotDetected: 'cloud_table_data_not_detected',
    CloudTablePushToRedshiftFailed: 'cloud_table_push_to_redshift_failed',
    CloudTableConnectorUnableToRefresh: 'cloud_table_connector_unable_to_refresh',
    ChargebeeUnknownError: 'chargebee_unknown_error',
    WritebackInProgress: 'writeback_in_progress',
    NotionUnknownError: 'notion_unknown_error',
    NotionRateLimitExceeded: 'notion_rate_limit_exceeded',
    NotionServiceUnavailable: 'notion_service_unavailable',
    NotionNotFound: 'notion_not_found',
    NotionBadRequest: 'notion_bad_request',
    NotionServerError: 'notion_server_error',
    NotionUnauthorizedRequest: 'notion_unauthorized_request',
    NotionDatabaseEmptyError: 'notion_database_empty_error',
    LinkedinAdsBadRequestError: 'linkedin_ads_bad_request_error',
    LinkedinAdsUnauthorizedError: 'linkedin_ads_unauthorized_error',
    LinkedinAdsAccessDeniedError: 'linkedin_ads_access_denied_error',
    LinkedinAdsResourceNotFoundError: 'linkedin_ads_resource_not_found_error',
    LinkedinAdsMethodNotAllowedError: 'linkedin_ads_method_not_allowed_error',
    LinkedinAdsRateLimitError: 'linkedin_ads_rate_limit_error',
    LinkedinAdsInternalServerError: 'linkedin_ads_internal_server_error',
    LinkedinAdsGatewayTimeoutError: 'linkedin_ads_gateway_timeout_error',
    LinkedinAdsTooLongRequestError: 'linkedin_ads_too_long_request_error',
    LinkedinAdsVersionDeprecatedError: 'linkedin_ads_version_deprecated_error',
    LinkedinAdsUnknownError: 'linkedin_ads_unknown_error',
    LinkedinAdsNoMetricsSelectedError: 'linkedin_ads_no_metrics_selected_error',
    LinkedinAdsAccountMismatchOnImportError: 'linkedin_ads_account_mismatch_on_import_error',
    YoutubeAnalyticsUnknownError: 'youtube_analytics_unknown_error',
    YoutubeAnalyticsBadRequest: 'youtube_analytics_bad_request',
    YoutubeAnalyticsQueryNotSupported: 'youtube_analytics_query_not_supported',
    YoutubeAnalyticsAuthError: 'youtube_analytics_auth_error',
    YoutubeAnalyticsServiceUnavailable: 'youtube_analytics_service_unavailable',
    YoutubeAnalyticsRateLimitExceeded: 'youtube_analytics_rate_limit_exceeded',
    YoutubeAnalyticsForbiddenAccess: 'youtube_analytics_forbidden_access',
    YoutubeAnalyticsIncompleteInputProvided: 'youtube_analytics_incomplete_input_provided',
    LinkedinPagesBadRequestError: 'linkedin_pages_bad_request_error',
    LinkedinPagesUnauthorizedError: 'linkedin_pages_unauthorized_error',
    LinkedinPagesAccessDeniedError: 'linkedin_pages_access_denied_error',
    LinkedinPagesResourceNotFoundError: 'linkedin_pages_resource_not_found_error',
    LinkedinPagesMethodNotAllowedError: 'linkedin_pages_method_not_allowed_error',
    LinkedinPagesRateLimitError: 'linkedin_pages_rate_limit_error',
    LinkedinPagesInternalServerError: 'linkedin_pages_internal_server_error',
    LinkedinPagesGatewayTimeoutError: 'linkedin_pages_gateway_timeout_error',
    LinkedinPagesUnknownError: 'linkedin_pages_unknown_error',
    LinkedinPagesNoParametersError: 'linkedin_pages_no_parameters_error',
    LinkedinPagesDateRangeError: 'linkedin_pages_date_range_error',
    MicrosoftAdsNoMetricsError: 'microsoft_ads_no_metrics_error',
    MicrosoftAdsColumnSelectionError: 'microsoft_ads_column_selection_error',
    MicrosoftAdsUnknownError: 'microsoft_ads_unknown_error',
    XeroServiceUnavailable: 'xero_service_unavailable',
    XeroObjectNotFound: 'xero_object_not_found',
    XeroInvalidFilter: 'xero_invalid_filter',
    XeroOrganizationNotAvailable: 'xero_organization_not_available',
    XeroReportNotAvailableForRegion: 'xero_report_not_available_for_region',
    KlaviyoUnknownError: 'klaviyo_unknown_error',
    HarvestUnknownError: 'harvest_unknown_error',
    GoogleCalendarServiceUnavailable: 'google_calendar_service_unavailable',
    AmazonSellerCentralServiceUnavailable: 'amazon_seller_central_service_unavailable',
    AmazonSellerCentralUnauthorized: 'amazon_seller_central_unauthorized',
    AmazonSellerCentralInvalidMarketplace: 'amazon_seller_central_invalid_marketplace',
    AmazonSellerCentralMissingRole: 'amazon_seller_central_missing_role',
    GoogleClassroomServiceUnavailable: 'google_classroom_service_unavailable',
    GreenhouseUnknownError: 'greenhouse_unknown_error',
    NetsuiteBadRequestError: 'netsuite_bad_request_error',
    NetsuiteNoTransactionDataInAccount: 'netsuite_no_transaction_data_in_account',
    NetsuiteUnauthorizedError: 'netsuite_unauthorized_error',
    NetsuiteAccessDeniedError: 'netsuite_access_denied_error',
    NetsuiteResourceNotFoundError: 'netsuite_resource_not_found_error',
    NetsuiteRecordNotFoundError: 'netsuite_record_not_found_error',
    NetsuiteAppInfoNotFoundError: 'netsuite_app_info_not_found_error',
    NetsuiteInvalidRestletError: 'netsuite_invalid_restlet_error',
    NetsuiteInvalidFileExtensionError: 'netsuite_invalid_file_extension_error',
    NetsuiteSavedSearchNotSupportedError: 'netsuite_saved_search_not_supported_error',
    NetsuiteRecordsSyntaxError: 'netsuite_records_syntax_error',
    NetsuiteMethodNotAllowedError: 'netsuite_method_not_allowed_error',
    NetsuiteRateLimitError: 'netsuite_rate_limit_error',
    NetsuiteInternalServerError: 'netsuite_internal_server_error',
    NetsuiteGatewayTimeoutError: 'netsuite_gateway_timeout_error',
    NetsuiteUnsupportedOperationError: 'netsuite_unsupported_operation_error',
    NetsuiteUnknownError: 'netsuite_unknown_error',
    NetsuiteReportsUnbalancedPartitionsError: 'netsuite_reports_unbalanced_partitions_error',
    NetsuiteNoAccessToReport: 'netsuite_no_access_to_report',
    NetsuiteNoAccessToAccountingPeriod: 'netsuite_no_access_to_accounting_period',
    NetsuiteInvalidMetadata: 'netsuite_invalid_metadata',
    NetsuitePermissionPreferenceNotSet: 'netsuite_permission_preference_not_set',
    NetsuiteInsufficientPermissionForFeature: 'netsuite_insufficient_permission_for_feature',
    NetsuiteInvalidLogin: 'netsuite_invalid_login',
    NetsuiteAgentApiGwEntryNotFound: 'netsuite_agent_api_gw_entry_not_found',
    NetsuiteAgentInvalidUrl: 'netsuite_agent_invalid_url',
    NetsuiteAgentUnsupportedUrl: 'netsuite_agent_unsupported_url',
    NetsuiteAgentUnsupportedFileFormat: 'netsuite_agent_unsupported_file_format',
    NetsuiteAgentFailedToFetchData: 'netsuite_agent_failed_to_fetch_data',
    NetsuiteAgentCrxRunAttemptFailed: 'netsuite_agent_crx_run_attempt_failed',
    NetsuiteAgentFailedToApplyFilters: 'netsuite_agent_failed_to_apply_filters',
    NetsuiteAgentAccountLoggedOut: 'netsuite_agent_account_logged_out',
    NetsuiteAgentFailedToSendWebsocketMessage: 'netsuite_agent_failed_to_send_websocket_message',
    NetsuiteAgentXmlParsingError: 'netsuite_agent_xml_parsing_error',
    NetsuiteAgentCsvParsingError: 'netsuite_agent_csv_parsing_error',
    NetsuiteAgentBlockNonOwnerRefresh: 'netsuite_agent_block_non_owner_refresh',
    NetsuiteAgentSsUnableToAcquireLock: 'netsuite_agent_ss_unable_to_acquire_lock',
    NetsuiteAgentErrorPageDetected: 'netsuite_agent_error_page_detected',
    NetsuiteAgentReportStillGenerating: 'netsuite_agent_report_still_generating',
    CustomApiUnauthorized: 'custom_api_unauthorized',
    CustomApiForbidden: 'custom_api_forbidden',
    CustomApiBadRequest: 'custom_api_bad_request',
    CustomApiNotFound: 'custom_api_not_found',
    CustomApiInternalServerError: 'custom_api_internal_server_error',
    CustomApiTemporaryError: 'custom_api_temporary_error',
    CustomApiSourceError: 'custom_api_source_error',
    CustomApiInvalidJsonResponse: 'custom_api_invalid_json_response',
    CustomApiInvalidUrl: 'custom_api_invalid_url',
    CustomApiSandboxExecutionError: 'custom_api_sandbox_execution_error',
    InvalidInputsProvided: 'invalid_inputs_provided',
    XeroApiRateLimitExceeded: 'xero_api_rate_limit_exceeded',
    AsanaInvalidProjectId: 'asana_invalid_project_id',
    DatabricksInvalidPatToken: 'databricks_invalid_pat_token',
    DatabricksInvalidOauthToken: 'databricks_invalid_oauth_token',
    DatabricksCatalogNotFound: 'databricks_catalog_not_found',
    DatabricksInvalidResourceDetails: 'databricks_invalid_resource_details',
    DatabricksInvalidJdbcUrl: 'databricks_invalid_jdbc_url',
    DatabricksUnknownError: 'databricks_unknown_error',
    DatabricksInvalidSchema: 'databricks_invalid_schema',
    ArrowFlightSqlInvalidToken: 'arrow_flight_sql_invalid_token',
    ArrowFlightSqlConnectionError: 'arrow_flight_sql_connection_error',
    ArrowFlightSqlUnknownError: 'arrow_flight_sql_unknown_error',
    ExcelColumnNameTooLong: 'excel_column_name_too_long',
    InvalidPivotInput: 'invalid_pivot_input',
    JotformForbiddenError: 'jotform_forbidden_error',
    ExcelAddinBatchRequestsThrottled: 'excel_addin_batch_requests_throttled',
    ExcelApiUnavailable: 'excel_api_unavailable',
    ExcelApiGatewayTimeout: 'excel_api_gateway_timeout',
    ExcelAddinBatchRequestsFailed: 'excel_addin_batch_requests_failed',
    ExcelAddinInvalidRefreshTokenError: 'excel_addin_invalid_refresh_token_error',
    ExcelAddinInsufficientMsPermissions: 'excel_addin_insufficient_ms_permissions',
    ExcelUrlBlockedDomain: 'excel_url_blocked_domain',
    ExcelWorkbookHasHugeNumberOfScheduledImports: 'excel_workbook_has_huge_number_of_scheduled_imports',
    ExcelScheduledRunPartiallyExecuted: 'excel_scheduled_run_partially_executed',
    ExcelUnknownError: 'excel_unknown_error',
    Ga4IncompleteDataError: 'ga4_incomplete_data_error',
    Ga4ActiveMetricRestrictionError: 'ga4_active_metric_restriction_error',
    InvalidAmplitudeChartUrl: 'invalid_amplitude_chart_url',
    UnsupportedAmplitudeChartType: 'unsupported_amplitude_chart_type',
    AnotherVcrSessionInProgressForLongTime: 'another_vcr_session_in_progress_for_long_time',
    CantStartVcrInstance: 'cant_start_vcr_instance',
    CantAttachUserToVcrInstance: 'cant_attach_user_to_vcr_instance',
    VcrUnknownError: 'vcr_unknown_error',
    VcrTooManyParallelRuns: 'vcr_too_many_parallel_runs',
    VcrAuthSessionInProgress: 'vcr_auth_session_in_progress',
    NoVcrInstanceAvailable: 'no_vcr_instance_available',
    ApolloUnknownError: 'apollo_unknown_error',
    ApolloBadRequest: 'apollo_bad_request',
    ApolloServiceUnavailable: 'apollo_service_unavailable',
    ApolloRateLimitExceeded: 'apollo_rate_limit_exceeded',
    ApolloDataNotFound: 'apollo_data_not_found',
    AwsBillingInvalidCredentials: 'aws_billing_invalid_credentials',
    AwsBillingValidationError: 'aws_billing_validation_error',
    AwsBillingAccessDenied: 'aws_billing_access_denied',
    AwsBillingUnknownError: 'aws_billing_unknown_error',
    AwsBillingMax2GroupBysError: 'aws_billing_max_2_group_bys_error',
    SageInvalidCredentials: 'sage_invalid_credentials',
    SageValidationError: 'sage_validation_error',
    SageAccessDenied: 'sage_access_denied',
    SageRecordsAccessDenied: 'sage_records_access_denied',
    SageReportNotFound: 'sage_report_not_found',
    SageDateFormatError: 'sage_date_format_error',
    SageUnknownError: 'sage_unknown_error',
    OpenaiTimeoutError: 'openai_timeout_error',
    OpenaiUnknownError: 'openai_unknown_error'
};
exports.DataImportRunTaskStage = {
    InQueue: 'in_queue',
    InProgress: 'in_progress',
    Done: 'done'
};
exports.DataImportStatusLevel = {
    Warning: 'warning',
    Error: 'error'
};
exports.DataImportWarningType = {
    NoMatchingRows: 'no_matching_rows',
    ReferEmptyCells: 'refer_empty_cells',
    NoNewMatchingRows: 'no_new_matching_rows',
    DataSourceChangedRerunImport: 'data_source_changed_rerun_import',
    NoSourceRowsToImport: 'no_source_rows_to_import',
    LookerPivotLookPreviewNotAvailable: 'looker_pivot_look_preview_not_available',
    ImportExceededSpecifiedLimit: 'import_exceeded_specified_limit',
    ImportExceededDataSourceLimit: 'import_exceeded_data_source_limit',
    ImportColumnsMissingInSource: 'import_columns_missing_in_source',
    LookerNoDownloadWithoutLimitPermission: 'looker_no_download_without_limit_permission',
    ImportRowsLimitedDueToFreemium: 'import_rows_limited_due_to_freemium',
    SalesforceReportRestApiFallback: 'salesforce_report_rest_api_fallback',
    SalesforceReportColumnLimit: 'salesforce_report_column_limit',
    SalesforceReportColumnAndRowLimit: 'salesforce_report_column_and_row_limit',
    SalesforceReportNoIdColumnDegraded: 'salesforce_report_no_id_column_degraded',
    SalesforceReportLongTextTruncated: 'salesforce_report_long_text_truncated',
    SnapshotFailedCellLimitExceeded: 'snapshot_failed_cell_limit_exceeded',
    ShopifyExceededTimeLimit: 'shopify_exceeded_time_limit',
    OnsheetFormulaAutofillFailed: 'onsheet_formula_autofill_failed',
    OnsheetFormulaAutofillRetryAsync: 'onsheet_formula_autofill_retry_async',
    NewRunTriggeredBeforeRetryAsync: 'new_run_triggered_before_retry_async',
    CloudTableConnectorUnableToRefresh: 'cloud_table_connector_unable_to_refresh',
    Ga4ImportHasIncompleteData: 'ga4_import_has_incomplete_data',
    Ga4ImportHasActiveMetricRestriction: 'ga4_import_has_active_metric_restriction',
    Ga4ImportHasSampledData: 'ga4_import_has_sampled_data',
    YoutubeAnalyticsImportHasIncompleteData: 'youtube_analytics_import_has_incomplete_data',
    AbandonedSpreadsheetScheduleRemoved: 'abandoned_spreadsheet_schedule_removed',
    DemoAccountScheduleRemoved: 'demo_account_schedule_removed',
    LookerFillDownValuesDisabled: 'looker_fill_down_values_disabled',
    LookerImportColumnsRemovedInSource: 'looker_import_columns_removed_in_source',
    LookerDashboardFilterNotSupportedForMergeQuery: 'looker_dashboard_filter_not_supported_for_merge_query',
    LookerFilterNotSupportedForMergeQuery: 'looker_filter_not_supported_for_merge_query',
    NetflixQuiverImportColumnsRemovedInSource: 'netflix_quiver_import_columns_removed_in_source',
    CustomApiEmptyResponse: 'custom_api_empty_response',
    NetsuiteOutdatedRestletWarning: 'netsuite_outdated_restlet_warning',
    ShopifyDeprecatedFields: 'shopify_deprecated_fields',
    FbAdsImportHasDeprecatedMetrics: 'fb_ads_import_has_deprecated_metrics',
    FbAdsDeprecatedMetricsAutoremoved: 'fb_ads_deprecated_metrics_autoremoved',
    FbInsightsDeprecatedMetrics: 'fb_insights_deprecated_metrics',
    NetsuiteOffsetErrorWarning: 'netsuite_offset_error_warning',
    NetsuiteCustomFieldMetadataPermissionWarning: 'netsuite_custom_field_metadata_permission_warning',
    PivotPreviewMaxSizeExceeded: 'pivot_preview_max_size_exceeded',
    PivotRawDataMaxSizeExceeded: 'pivot_raw_data_max_size_exceeded',
    GmailNoNewEmails: 'gmail_no_new_emails',
    GmailNoNewRows: 'gmail_no_new_rows',
    InstagramDeprecatedFields: 'instagram_deprecated_fields',
    QuickbooksReportExceedsCellLimit: 'quickbooks_report_exceeds_cell_limit',
    HubspotLimitReset: 'hubspot_limit_reset',
    PivotTooManyColumns: 'pivot_too_many_columns',
    PipedriveImportColumnsRemovedInSource: 'pipedrive_import_columns_removed_in_source',
    SageImportHasIncompleteData: 'sage_import_has_incomplete_data',
    SageImportContinuationInProgress: 'sage_import_continuation_in_progress',
    XeroReportTruncated: 'xero_report_truncated'
};
exports.DataSourceType = {
    Csv: 'csv',
    GoogleSheets: 'google_sheets',
    Salesforce: 'salesforce',
    GptCopilot: 'gpt_copilot',
    Looker: 'looker',
    GoogleAnalytics: 'google_analytics',
    Hubspot: 'hubspot',
    Tableau: 'tableau',
    Jira: 'jira',
    Stripe: 'stripe',
    Zendesk: 'zendesk',
    Quickbooks: 'quickbooks',
    Shopify: 'shopify',
    GoogleDrive: 'google_drive',
    Excel: 'excel',
    Airtable: 'airtable',
    Mailchimp: 'mailchimp',
    Pipedrive: 'pipedrive',
    OneDrive: 'one_drive',
    SharepointLists: 'sharepoint_lists',
    Egnyte: 'egnyte',
    Box: 'box',
    Outreach: 'outreach',
    GoogleAnalytics4: 'google_analytics_4',
    GoogleSearchConsole: 'google_search_console',
    GoogleAds: 'google_ads',
    CloudTable: 'cloud_table',
    FacebookAds: 'facebook_ads',
    Notion: 'notion',
    Chargebee: 'chargebee',
    LinkedinAds: 'linkedin_ads',
    FacebookInsights: 'facebook_insights',
    YoutubeAnalytics: 'youtube_analytics',
    LinkedinPages: 'linkedin_pages',
    Linkedin: 'linkedin',
    CustomApi: 'custom_api',
    InstagramInsights: 'instagram_insights',
    MicrosoftAds: 'microsoft_ads',
    Netsuite: 'netsuite',
    NetsuiteCrx: 'netsuite_crx',
    Xero: 'xero',
    Klaviyo: 'klaviyo',
    Asana: 'asana',
    Razorpay: 'razorpay',
    Clickup: 'clickup',
    Typeform: 'typeform',
    Harvest: 'harvest',
    Freshdesk: 'freshdesk',
    Paymo: 'paymo',
    GoogleCalendar: 'google_calendar',
    AmazonSellerCentral: 'amazon_seller_central',
    Trello: 'trello',
    Gong: 'gong',
    Calendly: 'calendly',
    Smartsheet: 'smartsheet',
    RedditAds: 'reddit_ads',
    Surveymonkey: 'surveymonkey',
    QuoraAds: 'quora_ads',
    Podio: 'podio',
    Greenhouse: 'greenhouse',
    Gusto: 'gusto',
    Intercom: 'intercom',
    Etsy: 'etsy',
    PinterestAds: 'pinterest_ads',
    ActiveCampaign: 'active_campaign',
    Jotform: 'jotform',
    Basecamp: 'basecamp',
    Zohobooks: 'zohobooks',
    Coda: 'coda',
    Square: 'square',
    Zoom: 'zoom',
    Webflow: 'webflow',
    ZohoCrm: 'zoho_crm',
    Bigin: 'bigin',
    Lever: 'lever',
    Salesloft: 'salesloft',
    Wordpress: 'wordpress',
    WooCommerce: 'woo_commerce',
    Bigcommerce: 'bigcommerce',
    Smartlead: 'smartlead',
    Affinity: 'affinity',
    Shiprocket: 'shiprocket',
    AwsBilling: 'aws_billing',
    Gmail: 'gmail',
    Sage: 'sage',
    GoogleClassroom: 'google_classroom',
    Campfire: 'campfire',
    Rillet: 'rillet',
    NetflixQuiver: 'netflix_quiver',
    AnyApiAgent: 'any_api_agent',
    BrowserAgent: 'browser_agent',
    Mysql: 'mysql',
    Redshift: 'redshift',
    Postgres: 'postgres',
    Snowflake: 'snowflake',
    Mssql: 'mssql',
    Bigquery: 'bigquery',
    Databricks: 'databricks',
    ArrowFlightSql: 'arrow_flight_sql',
    Motherduck: 'motherduck',
    Clickhouse: 'clickhouse',
    AuroraPostgres: 'aurora_postgres',
    AuroraMysql: 'aurora_mysql',
    CloudSqlPostgres: 'cloud_sql_postgres',
    CloudSqlMysql: 'cloud_sql_mysql',
    Supabase: 'supabase',
    Neon: 'neon',
    Timescaledb: 'timescaledb',
    AzurePostgres: 'azure_postgres',
    AzureMysql: 'azure_mysql',
    AzureSql: 'azure_sql',
    Rippling: 'rippling',
    Apollo: 'apollo',
    Amplitude: 'amplitude',
    Sendgrid: 'sendgrid',
    Chargify: 'chargify',
    Marketo: 'marketo',
    Mongodb: 'mongodb',
    WebScraper: 'web_scraper',
    ChargebeeAi: 'chargebee_ai',
    StripeAi: 'stripe_ai',
    OutreachAi: 'outreach_ai',
    ClickupAi: 'clickup_ai',
    JiraAi: 'jira_ai',
    SquareAi: 'square_ai',
    ExpensifyAi: 'expensify_ai',
    TwilioAi: 'twilio_ai',
    SendgridAi: 'sendgrid_ai',
    KitAi: 'kit_ai',
    InsightlyAi: 'insightly_ai',
    FreshsalesAi: 'freshsales_ai',
    CloseAi: 'close_ai',
    XeroAi: 'xero_ai',
    ModeAi: 'mode_ai',
    MondayAi: 'monday_ai',
    MixpanelAi: 'mixpanel_ai',
    ClockifyAi: 'clockify_ai',
    KobotoolboxAi: 'kobotoolbox_ai',
    TogglTrackAi: 'toggl_track_ai',
    SmartsuiteAi: 'smartsuite_ai',
    OdooAi: 'odoo_ai',
    LinearAi: 'linear_ai',
    KlaviyoAi: 'klaviyo_ai',
    RazorpayAi: 'razorpay_ai',
    PaymoAi: 'paymo_ai',
    ActiveCampaignAi: 'active_campaign_ai',
    WordpressAi: 'wordpress_ai',
    WooCommerceAi: 'woo_commerce_ai',
    SmartleadAi: 'smartlead_ai',
    ShiprocketAi: 'shiprocket_ai',
    RipplingAi: 'rippling_ai',
    HarvestAi: 'harvest_ai',
    CalendlyAi: 'calendly_ai',
    ZohobooksAi: 'zohobooks_ai',
    ZohoCrmAi: 'zoho_crm_ai',
    BiginAi: 'bigin_ai',
    ApolloAi: 'apollo_ai',
    FreshdeskAi: 'freshdesk_ai',
    GreenhouseAi: 'greenhouse_ai',
    TrelloAi: 'trello_ai',
    JotformAi: 'jotform_ai',
    CodaAi: 'coda_ai',
    TypeformAi: 'typeform_ai',
    PodioAi: 'podio_ai',
    SmartsheetAi: 'smartsheet_ai',
    BasecampAi: 'basecamp_ai',
    MetabaseAi: 'metabase_ai',
    TeamworkAi: 'teamwork_ai',
    CatsAtsAi: 'cats_ats_ai',
    NutshellAi: 'nutshell_ai',
    PipelinerAi: 'pipeliner_ai',
    SalesflareAi: 'salesflare_ai',
    VtigerCrmAi: 'vtiger_crm_ai',
    FreshserviceAi: 'freshservice_ai',
    HiveAi: 'hive_ai',
    AircallAi: 'aircall_ai',
    NimbleCrmAi: 'nimble_crm_ai',
    DripAi: 'drip_ai',
    PaddleAi: 'paddle_ai',
    AgileCrmAi: 'agile_crm_ai',
    CheckoutAi: 'checkout_ai',
    CapsuleAi: 'capsule_ai',
    BitbucketAi: 'bitbucket_ai',
    GitlabAi: 'gitlab_ai',
    HelpscoutAi: 'helpscout_ai',
    FrontAi: 'front_ai',
    WrikeAi: 'wrike_ai',
    BamboohrAi: 'bamboohr_ai',
    DeelAi: 'deel_ai',
    ConfluenceAi: 'confluence_ai',
    TeamleaderAi: 'teamleader_ai',
    MiroAi: 'miro_ai',
    OmnisendAi: 'omnisend_ai',
    AttioAi: 'attio_ai',
    CreatioAi: 'creatio_ai',
    FreeagentAi: 'freeagent_ai',
    MoneybirdAi: 'moneybird_ai',
    AcceloAi: 'accelo_ai',
    ApplicantstackAi: 'applicantstack_ai',
    AlowareAi: 'aloware_ai',
    StackbyAi: 'stackby_ai',
    FloatAi: 'float_ai',
    ClickhouseAi: 'clickhouse_ai',
    AppsflyerAi: 'appsflyer_ai',
    MariadbAi: 'mariadb_ai',
    LaunchdarklyAi: 'launchdarkly_ai',
    PosthogAi: 'posthog_ai',
    DovetailAi: 'dovetail_ai',
    ShipstationAi: 'shipstation_ai',
    MindbodyAi: 'mindbody_ai',
    GrowwAi: 'groww_ai',
    AmazonSellerCentralAi: 'amazon_seller_central_ai',
    AirwallexAi: 'airwallex_ai',
    StatsigAi: 'statsig_ai',
    ModernTreasuryAi: 'modern_treasury_ai',
    RudderstackAi: 'rudderstack_ai',
    BrightDataAi: 'bright_data_ai',
    VwoAi: 'vwo_ai',
    PartnerizeAi: 'partnerize_ai',
    RilletAi: 'rillet_ai',
    TrolleyAi: 'trolley_ai',
    ScalefusionAi: 'scalefusion_ai',
    BaremetricsAi: 'baremetrics_ai',
    TodoistAi: 'todoist_ai',
    WorkableAi: 'workable_ai',
    PlausibleAi: 'plausible_ai',
    ApifyAi: 'apify_ai',
    DatascopeAi: 'datascope_ai',
    GorgiasAi: 'gorgias_ai',
    EverhourAi: 'everhour_ai',
    ExchangeratesAi: 'exchangerates_ai',
    FastbillAi: 'fastbill_ai',
    GlassfrogAi: 'glassfrog_ai',
    ResourceFlowHubplannerAi: 'resource_flow_hubplanner_ai',
    KatanaAi: 'katana_ai',
    MyhoursAi: 'myhours_ai',
    FisRailzAi: 'fis_railz_ai',
    TellentHrisAi: 'tellent_hris_ai',
    SimfinAi: 'simfin_ai',
    SmartwaiverAi: 'smartwaiver_ai',
    LokaliseAi: 'lokalise_ai',
    MailerliteAi: 'mailerlite_ai',
    MailersendAi: 'mailersend_ai',
    OnesignalAi: 'onesignal_ai',
    PostmarkAi: 'postmark_ai',
    ShortIoAi: 'short_io_ai',
    YotpoAi: 'yotpo_ai',
    ChartmogulAi: 'chartmogul_ai',
    ConfigcatAi: 'configcat_ai',
    PingdomAi: 'pingdom_ai',
    RetentlyAi: 'retently_ai',
    CoinmarketcapAi: 'coinmarketcap_ai',
    SoftrIoAi: 'softr_io_ai',
    EmailoctopusAi: 'emailoctopus_ai',
    GridlyAi: 'gridly_ai',
    MixmaxAi: 'mixmax_ai',
    ReplyIoAi: 'reply_io_ai',
    LessAnnoyingCrmAi: 'less_annoying_crm_ai',
    SnovIoAi: 'snov_io_ai',
    OnepagecrmAi: 'onepagecrm_ai',
    LemlistAi: 'lemlist_ai'
};
exports.GlobalSettingType = {
    BetaGsuiteDomains: 'beta_gsuite_domains'
};
exports.SnapshotType = {
    EntireTab: 'Entire tab',
    SpecificRange: 'Specific range'
};
exports.SubscriptionPlanType = {
    NewUser: 'new_user',
    FreeTrial: 'free_trial',
    LifetimeFree: 'lifetime_free',
    Starter: 'starter',
    Plus: 'plus',
    Pro: 'pro',
    Custom: 'custom',
    Enterprise: 'enterprise'
};
var DefaultApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        completeAlertsTransfer: function (complete_alerts_transfer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/alerts_transfer/complete/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(complete_alerts_transfer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        completeCloudTablesTransfer: function (complete_cloud_tables_transfer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/cloud_tables_transfer/complete/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(complete_cloud_tables_transfer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        completeSnapshotsTransfer: function (complete_snapshots_transfer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/snapshots_transfer/complete/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(complete_snapshots_transfer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getAlerts: function (domain, page_size, offset, sort_by, sort_order, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getAlerts', 'domain', domain);
                    localVarPath = "/api_admin/alerts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (sort_by !== undefined) {
                        localVarQueryParameter['sort_by'] = sort_by;
                    }
                    if (sort_order !== undefined) {
                        localVarQueryParameter['sort_order'] = sort_order;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDataImports: function (domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDataImports', 'domain', domain);
                    localVarPath = "/api_admin/data_imports";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDomainEnforcementStatus: function (domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getDomainEnforcementStatus', 'domain', domain);
                    localVarPath = "/api_admin/domain_enforcement_status";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getDomains: function (search_by, offset, page_size, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/domains";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (search_by !== undefined) {
                        localVarQueryParameter['search_by'] = search_by;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (page_size !== undefined) {
                        localVarQueryParameter['page_size'] = page_size;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getGlobalSetting: function (global_setting_type_str, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getGlobalSetting', 'global_setting_type_str', global_setting_type_str);
                    localVarPath = "/api_admin/global_settings/{global_setting_type_str}"
                        .replace("{".concat("global_setting_type_str", "}"), encodeURIComponent(String(global_setting_type_str)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getOpenAIThreadMessages: function (thread_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getOpenAIThreadMessages', 'thread_id', thread_id);
                    localVarPath = "/api_admin/openai_thread_messages/{thread_id}"
                        .replace("{".concat("thread_id", "}"), encodeURIComponent(String(thread_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getQuickstartSpreadsheets: function (email, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getQuickstartSpreadsheets', 'email', email);
                    localVarPath = "/api_admin/quickstarts";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (email !== undefined) {
                        localVarQueryParameter['email'] = email;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getUserUpgradeToken: function (user_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getUserUpgradeToken', 'user_id', user_id);
                    localVarPath = "/api_admin/users/{user_id}/upgrade_token"
                        .replace("{".concat("user_id", "}"), encodeURIComponent(String(user_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        getUsers: function (domain, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('getUsers', 'domain', domain);
                    localVarPath = "/api_admin/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (domain !== undefined) {
                        localVarQueryParameter['domain'] = domain;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        initiateAlertsTransfer: function (initiate_alerts_transfer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/alerts_transfer/initiate/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initiate_alerts_transfer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        initiateCloudTablesTransfer: function (initiate_cloud_tables_transfer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/cloud_tables_transfer/initiate/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initiate_cloud_tables_transfer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        initiateSnapshotsTransfer: function (initiate_snapshots_transfer_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/snapshots_transfer/initiate/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(initiate_snapshots_transfer_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        netsuiteRestletInfo: function (data_source_id, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('netsuiteRestletInfo', 'data_source_id', data_source_id);
                    localVarPath = "/api_admin/netsuite_restlet_info/{data_source_id}"
                        .replace("{".concat("data_source_id", "}"), encodeURIComponent(String(data_source_id)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        setDomainEnforcement: function (set_domain_enforcement_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/set_domain_enforcement/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(set_domain_enforcement_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        setDomainLevelSettingsFlags: function (set_domain_level_settings_flags_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/set_domain_level_settings_flags/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(set_domain_level_settings_flags_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        setUserLevelFlags: function (set_user_level_flags_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    localVarPath = "/api_admin/set_user_level_flags/";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(set_user_level_flags_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        upsertGlobalSetting: function (global_setting_type_str, upsert_global_setting_request, options) {
            if (options === void 0) { options = {}; }
            return __awaiter(_this, void 0, void 0, function () {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                return __generator(this, function (_a) {
                    (0, common_1.assertParamExists)('upsertGlobalSetting', 'global_setting_type_str', global_setting_type_str);
                    localVarPath = "/api_admin/global_settings/{global_setting_type_str}"
                        .replace("{".concat("global_setting_type_str", "}"), encodeURIComponent(String(global_setting_type_str)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(upsert_global_setting_request, localVarRequestOptions, configuration);
                    return [2, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.DefaultApiAxiosParamCreator = DefaultApiAxiosParamCreator;
var DefaultApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.DefaultApiAxiosParamCreator)(configuration);
    return {
        completeAlertsTransfer: function (complete_alerts_transfer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.completeAlertsTransfer(complete_alerts_transfer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        completeCloudTablesTransfer: function (complete_cloud_tables_transfer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.completeCloudTablesTransfer(complete_cloud_tables_transfer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        completeSnapshotsTransfer: function (complete_snapshots_transfer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.completeSnapshotsTransfer(complete_snapshots_transfer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getAlerts: function (domain, page_size, offset, sort_by, sort_order, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getAlerts(domain, page_size, offset, sort_by, sort_order, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDataImports: function (domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDataImports(domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDomainEnforcementStatus: function (domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDomainEnforcementStatus(domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getDomains: function (search_by, offset, page_size, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getDomains(search_by, offset, page_size, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getGlobalSetting: function (global_setting_type_str, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getGlobalSetting(global_setting_type_str, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getOpenAIThreadMessages: function (thread_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getOpenAIThreadMessages(thread_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getQuickstartSpreadsheets: function (email, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getQuickstartSpreadsheets(email, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getUserUpgradeToken: function (user_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getUserUpgradeToken(user_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        getUsers: function (domain, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.getUsers(domain, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        initiateAlertsTransfer: function (initiate_alerts_transfer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.initiateAlertsTransfer(initiate_alerts_transfer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        initiateCloudTablesTransfer: function (initiate_cloud_tables_transfer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.initiateCloudTablesTransfer(initiate_cloud_tables_transfer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        initiateSnapshotsTransfer: function (initiate_snapshots_transfer_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.initiateSnapshotsTransfer(initiate_snapshots_transfer_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        netsuiteRestletInfo: function (data_source_id, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.netsuiteRestletInfo(data_source_id, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        setDomainEnforcement: function (set_domain_enforcement_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.setDomainEnforcement(set_domain_enforcement_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        setDomainLevelSettingsFlags: function (set_domain_level_settings_flags_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.setDomainLevelSettingsFlags(set_domain_level_settings_flags_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        setUserLevelFlags: function (set_user_level_flags_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.setUserLevelFlags(set_user_level_flags_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
        upsertGlobalSetting: function (global_setting_type_str, upsert_global_setting_request, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, localVarAxiosParamCreator.upsertGlobalSetting(global_setting_type_str, upsert_global_setting_request, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2, (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
exports.DefaultApiFp = DefaultApiFp;
var DefaultApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.DefaultApiFp)(configuration);
    return {
        completeAlertsTransfer: function (complete_alerts_transfer_request, options) {
            return localVarFp.completeAlertsTransfer(complete_alerts_transfer_request, options).then(function (request) { return request(axios, basePath); });
        },
        completeCloudTablesTransfer: function (complete_cloud_tables_transfer_request, options) {
            return localVarFp.completeCloudTablesTransfer(complete_cloud_tables_transfer_request, options).then(function (request) { return request(axios, basePath); });
        },
        completeSnapshotsTransfer: function (complete_snapshots_transfer_request, options) {
            return localVarFp.completeSnapshotsTransfer(complete_snapshots_transfer_request, options).then(function (request) { return request(axios, basePath); });
        },
        getAlerts: function (domain, page_size, offset, sort_by, sort_order, options) {
            return localVarFp.getAlerts(domain, page_size, offset, sort_by, sort_order, options).then(function (request) { return request(axios, basePath); });
        },
        getDataImports: function (domain, options) {
            return localVarFp.getDataImports(domain, options).then(function (request) { return request(axios, basePath); });
        },
        getDomainEnforcementStatus: function (domain, options) {
            return localVarFp.getDomainEnforcementStatus(domain, options).then(function (request) { return request(axios, basePath); });
        },
        getDomains: function (search_by, offset, page_size, options) {
            return localVarFp.getDomains(search_by, offset, page_size, options).then(function (request) { return request(axios, basePath); });
        },
        getGlobalSetting: function (global_setting_type_str, options) {
            return localVarFp.getGlobalSetting(global_setting_type_str, options).then(function (request) { return request(axios, basePath); });
        },
        getOpenAIThreadMessages: function (thread_id, options) {
            return localVarFp.getOpenAIThreadMessages(thread_id, options).then(function (request) { return request(axios, basePath); });
        },
        getQuickstartSpreadsheets: function (email, options) {
            return localVarFp.getQuickstartSpreadsheets(email, options).then(function (request) { return request(axios, basePath); });
        },
        getUserUpgradeToken: function (user_id, options) {
            return localVarFp.getUserUpgradeToken(user_id, options).then(function (request) { return request(axios, basePath); });
        },
        getUsers: function (domain, options) {
            return localVarFp.getUsers(domain, options).then(function (request) { return request(axios, basePath); });
        },
        initiateAlertsTransfer: function (initiate_alerts_transfer_request, options) {
            return localVarFp.initiateAlertsTransfer(initiate_alerts_transfer_request, options).then(function (request) { return request(axios, basePath); });
        },
        initiateCloudTablesTransfer: function (initiate_cloud_tables_transfer_request, options) {
            return localVarFp.initiateCloudTablesTransfer(initiate_cloud_tables_transfer_request, options).then(function (request) { return request(axios, basePath); });
        },
        initiateSnapshotsTransfer: function (initiate_snapshots_transfer_request, options) {
            return localVarFp.initiateSnapshotsTransfer(initiate_snapshots_transfer_request, options).then(function (request) { return request(axios, basePath); });
        },
        netsuiteRestletInfo: function (data_source_id, options) {
            return localVarFp.netsuiteRestletInfo(data_source_id, options).then(function (request) { return request(axios, basePath); });
        },
        setDomainEnforcement: function (set_domain_enforcement_request, options) {
            return localVarFp.setDomainEnforcement(set_domain_enforcement_request, options).then(function (request) { return request(axios, basePath); });
        },
        setDomainLevelSettingsFlags: function (set_domain_level_settings_flags_request, options) {
            return localVarFp.setDomainLevelSettingsFlags(set_domain_level_settings_flags_request, options).then(function (request) { return request(axios, basePath); });
        },
        setUserLevelFlags: function (set_user_level_flags_request, options) {
            return localVarFp.setUserLevelFlags(set_user_level_flags_request, options).then(function (request) { return request(axios, basePath); });
        },
        upsertGlobalSetting: function (global_setting_type_str, upsert_global_setting_request, options) {
            return localVarFp.upsertGlobalSetting(global_setting_type_str, upsert_global_setting_request, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.DefaultApiFactory = DefaultApiFactory;
var DefaultApi = (function (_super) {
    __extends(DefaultApi, _super);
    function DefaultApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DefaultApi.prototype.completeAlertsTransfer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).completeAlertsTransfer(requestParameters.complete_alerts_transfer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.completeCloudTablesTransfer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).completeCloudTablesTransfer(requestParameters.complete_cloud_tables_transfer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.completeSnapshotsTransfer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).completeSnapshotsTransfer(requestParameters.complete_snapshots_transfer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getAlerts = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getAlerts(requestParameters.domain, requestParameters.page_size, requestParameters.offset, requestParameters.sort_by, requestParameters.sort_order, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDataImports = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDataImports(requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDomainEnforcementStatus = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getDomainEnforcementStatus(requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getDomains = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).getDomains(requestParameters.search_by, requestParameters.offset, requestParameters.page_size, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getGlobalSetting = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getGlobalSetting(requestParameters.global_setting_type_str, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getOpenAIThreadMessages = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getOpenAIThreadMessages(requestParameters.thread_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getQuickstartSpreadsheets = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getQuickstartSpreadsheets(requestParameters.email, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getUserUpgradeToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUserUpgradeToken(requestParameters.user_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.getUsers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).getUsers(requestParameters.domain, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.initiateAlertsTransfer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).initiateAlertsTransfer(requestParameters.initiate_alerts_transfer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.initiateCloudTablesTransfer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).initiateCloudTablesTransfer(requestParameters.initiate_cloud_tables_transfer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.initiateSnapshotsTransfer = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).initiateSnapshotsTransfer(requestParameters.initiate_snapshots_transfer_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.netsuiteRestletInfo = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).netsuiteRestletInfo(requestParameters.data_source_id, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.setDomainEnforcement = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).setDomainEnforcement(requestParameters.set_domain_enforcement_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.setDomainLevelSettingsFlags = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).setDomainLevelSettingsFlags(requestParameters.set_domain_level_settings_flags_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.setUserLevelFlags = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.DefaultApiFp)(this.configuration).setUserLevelFlags(requestParameters.set_user_level_flags_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    DefaultApi.prototype.upsertGlobalSetting = function (requestParameters, options) {
        var _this = this;
        return (0, exports.DefaultApiFp)(this.configuration).upsertGlobalSetting(requestParameters.global_setting_type_str, requestParameters.upsert_global_setting_request, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DefaultApi;
}(base_1.BaseAPI));
exports.DefaultApi = DefaultApi;
